// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MessagingAnalytics_UnansweredByDayResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /config/messaging_analytics/unanswered_by_day.
 *
 * Returns unanswered/unread chat counts grouped by day, per device, for the
 * currently active filter's franchise + date window.
 *
 * Shape source: controllers/config/messaging_analytics.php :: unanswered_by_day
 * (the final $this->enviar["dados"] = [...] block).
 */
import type { MessagingAnalytics_UnansweredByDayDeviceRow } from './MessagingAnalytics_UnansweredByDayDeviceRow'
import type { MessagingAnalytics_UnansweredByDayPeriodoRow } from './MessagingAnalytics_UnansweredByDayPeriodoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface MessagingAnalytics_UnansweredByDayResponseDados {
periodo: MessagingAnalytics_UnansweredByDayPeriodoRow
por_dispositivo: MessagingAnalytics_UnansweredByDayDeviceRow[]
}

export type MessagingAnalytics_UnansweredByDayResponse = ApiResponse<MessagingAnalytics_UnansweredByDayResponseDados>;

registerResponseContract('MessagingAnalytics_UnansweredByDayResponse', {
  periodo: {
    type: 'object',
    required: true,
    fields: {
      inicio: { type: 'string',  required: false },
      fim:    { type: 'string',  required: false },
    },
  },
  por_dispositivo: {
    type: 'array',
    required: true,
    items: {
      device_name: { type: 'string',  required: false },
      por_dia: {
        type: 'array',
        required: false,
        items: {
          data:               { type: 'string',  required: false },
          chats_sem_resposta: { type: 'number',  required: false },
          chats_nao_lidos:    { type: 'number',  required: false },
        },
      },
    },
  },
})
